import React from "react";
import { Modal } from "antd";

const labelStyle = {
  padding: "8px 12px",
  fontWeight: 600,
  width: "35%",
  verticalAlign: "top",
  borderBottom: "1px solid #f0f0f0",
};

const valueStyle = {
  padding: "8px 12px",
  wordBreak: "break-word",
  borderBottom: "1px solid #f0f0f0",
};

// Fields not useful to an admin reviewing what a recipient received - the
// button's own link/text and the internal template-name key.
const HIDDEN_EMAIL_DATA_KEYS = ["email_btn_link", "email_btn_text", "email_name"];

const RecipientEmailDataModal = ({ isModalVisible, handleCancel, emailData, recipientLabel }) => {
  const entries = emailData
    ? Object.entries(emailData).filter(([key]) => !HIDDEN_EMAIL_DATA_KEYS.includes(key))
    : [];

  return (
    <Modal
      title={`Email Content${recipientLabel ? ` - ${recipientLabel}` : ""}`}
      open={isModalVisible}
      footer={null}
      width={700}
      onCancel={handleCancel}
      maskClosable={false}
    >
      {entries.length === 0 ? (
        <p>No email content saved for this recipient.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            {entries.map(([key, value]) => (
              <tr key={key}>
                <td style={labelStyle}>{key}</td>
                <td style={valueStyle}>{value === null || value === undefined || value === "" ? "-" : String(value)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Modal>
  );
};

export default RecipientEmailDataModal;
